var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoBf25WhitePt({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Capa_2",
    "data-name": "Capa 2",
    viewBox: "0 0 1156.13 566.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "994.9 566.46 0 566.46 161.24 0 1156.13 0 994.9 566.46",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M820.51,410.3c-.91,0-1.83-.02-2.77-.06-29.55-1.35-53.93-14.54-69.17-25.36-16.46-11.68-25.92-22.96-26.31-23.43l7.22-6.01c.09.11,9.22,10.96,24.76,21.94,14.17,10.02,36.77,22.23,63.94,23.47,22.79,1.03,34.18-12.97,39.73-24.9,10.27-22.11,7.14-50.49.1-58.1l6.89-6.38c10.26,11.09,13.16,43.4,1.53,68.44-9.14,19.68-25.38,30.39-45.91,30.39Z",
    fill: "#242424",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.07,383.34c-.09-.19-8.98-18.96-24.84-37.43-14.31-16.66-37.45-36.52-66.37-36.52-54.59,0-57.07,26.35-57.08,26.62l-9.37-.66c.1-1.44,3.21-35.35,66.45-35.35,25.78,0,51.25,13.82,73.65,39.97,16.64,19.43,25.7,38.59,26.07,39.39l-8.51,3.98Z",
    fill: "#242424",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "826.38 320.53 805.73 320.53 363.97 320.53 343.15 446.71 805.73 446.71 820.09 446.71 832.18 446.71 832.18 422.11 832.18 320.53 826.38 320.53",
    fill: "#da0d29",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317.68 343.76 192.79 343.76 192.79 107.65 340.7 107.65 317.68 343.76",
    fill: "#242424",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "479.66 310.3 340.7 310.3 361.51 74.18 500.47 74.18 479.66 310.3",
    fill: "#242424",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "640.79 292.43 501.84 292.43 522.65 56.32 661.61 56.32 640.79 292.43",
    fill: "#242424",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "798.14 310.3 659.19 310.3 680 74.18 818.96 74.18 798.14 310.3",
    fill: "#242424",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "957.73 111.6 839.11 111.6 833.3 111.6 812.49 347.71 839.11 347.71 951.44 347.71 963.54 347.71 963.54 229.65 963.54 111.6 957.73 111.6",
    fill: "#242424",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.93,312.18v-165.05h44.73c12,0,20.74,2.92,26.21,8.77,5.47,5.85,8.21,15.49,8.21,28.93v7.22c0,7.75-1.39,14.04-4.17,18.85-2.78,4.81-7.02,7.97-12.71,9.47,7.44,1.88,12.43,6.27,14.96,13.18,2.53,6.91,3.8,15.33,3.8,25.27,0,10.69-1,20.04-3,28.04-2,8-5.63,14.22-10.88,18.66-5.25,4.44-12.72,6.66-22.41,6.66h-44.73ZM255.19,209.3h6.75c3.06,0,5.03-1.19,5.91-3.56.87-2.38,1.31-5.22,1.31-8.53v-16.6c0-5.31-2.34-7.97-7.03-7.97h-6.94v36.67ZM258.48,283.11c8.56,0,12.85-4.06,12.85-12.19v-20.63c0-4.69-.7-8.39-2.11-11.11-1.41-2.72-4.05-4.08-7.92-4.08h-6.1v47.83c1.37.13,2.47.19,3.28.19Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.06,269.32l20.81-165.05h33.01l-20.81,136.92h33.95v28.13h-66.96Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.32,256.8l15.94-165.05h55.99l15.66,165.05h-31.23l-2.34-26.63h-19.88l-2.06,26.63h-32.07ZM571.8,203.82h15l-7.22-83.93h-1.5l-6.28,83.93Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M738.13,270.82c-11.94,0-21.55-3.72-28.84-11.16-7.28-7.44-10.92-17.85-10.92-31.23v-76.15c0-16,3.17-28.26,9.52-36.76,6.34-8.5,16.68-12.75,30.99-12.75,7.81,0,14.77,1.44,20.87,4.31,6.1,2.88,10.89,7.17,14.39,12.89,3.5,5.72,5.25,12.93,5.25,21.62v28.51h-32.82v-24.38c0-4.94-.63-8.27-1.88-9.99-1.25-1.72-3.19-2.58-5.81-2.58-3.06,0-5.13,1.11-6.19,3.33-1.06,2.22-1.59,5.17-1.59,8.86v82.62c0,4.56.67,7.78,2.02,9.66,1.34,1.88,3.27,2.81,5.77,2.81,2.81,0,4.8-1.16,5.95-3.47,1.16-2.31,1.73-5.31,1.73-9v-29.73h33.2v31.23c0,14.51-3.66,25.02-10.97,31.56-7.31,6.53-17.54,9.8-30.67,9.8Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.72,316.13v-165.05h32.63v66.11l15.38-66.11h33.2l-18.47,75.59,22.32,89.46h-34.23l-18.01-79.9v79.9h-32.82Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "343.15 446.71 518.11 491.48 518.11 446.71 343.15 446.71",
    fill: "#242424",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M585.04,475.54c0,6.97-5.61,12.58-12.85,12.58h-5.51v11.53h-8.39v-36.7h13.89c7.24,0,12.85,5.61,12.85,12.58ZM576.65,475.54c0-2.67-1.89-4.72-4.46-4.72h-5.51v9.44h5.51c2.57,0,4.46-2.04,4.46-4.72Z",
    fill: "#da0d29",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.72,493.36c2.15,0,3.98-.84,5.03-1.99l6.29,3.62c-2.57,3.57-6.45,5.4-11.43,5.4-8.97,0-14.52-6.03-14.52-13.84s5.66-13.84,13.95-13.84c7.65,0,13.32,5.93,13.32,13.84,0,1.1-.11,2.15-.32,3.15h-18.61c1,2.73,3.41,3.67,6.29,3.67ZM605.54,483.82c-.84-3.04-3.2-4.14-5.56-4.14-2.99,0-4.98,1.47-5.72,4.14h11.27Z",
    fill: "#da0d29",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.98,480.99v9.28c0,2.25,1.94,2.46,5.4,2.25v7.13c-10.28,1.05-13.26-2.05-13.26-9.39v-9.28h-4.19v-7.55h4.19v-4.98l7.86-2.36v7.34h5.4v7.55h-5.4Z",
    fill: "#da0d29",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.09,472.92v8.91c-3.25-.52-7.87.79-7.87,5.98v11.85h-7.86v-26.22h7.86v4.67c1.05-3.51,4.56-5.19,7.87-5.19Z",
    fill: "#da0d29",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.18,486.55c0-7.81,6.19-13.84,13.9-13.84s13.89,6.03,13.89,13.84-6.19,13.84-13.89,13.84-13.9-6.03-13.9-13.84ZM675.11,486.55c0-3.72-2.62-6.19-6.03-6.19s-6.03,2.46-6.03,6.19,2.62,6.19,6.03,6.19,6.03-2.46,6.03-6.19Z",
    fill: "#da0d29",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.12,486.55c0,7.81-5.66,13.84-12.53,13.84-3.51,0-6.08-1.21-7.81-3.2v12.95h-7.86v-36.7h7.86v2.46c1.73-1.99,4.3-3.2,7.81-3.2,6.87,0,12.53,6.03,12.53,13.84ZM707.25,486.55c0-3.93-2.62-6.4-6.24-6.4s-6.24,2.46-6.24,6.4,2.62,6.4,6.24,6.4,6.24-2.46,6.24-6.4Z",
    fill: "#da0d29",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735.3,473.44v8.91c-3.25-.52-7.87.79-7.87,5.98v11.33h-7.86v-26.22h7.86v5.19c1.05-3.51,4.56-5.19,7.87-5.19Z",
    fill: "#da0d29",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M738.18,466.41c0-2.57,2.15-4.72,4.72-4.72s4.72,2.15,4.72,4.72-2.15,4.72-4.72,4.72-4.72-2.15-4.72-4.72ZM738.97,473.44h7.86v26.22h-7.86v-26.22Z",
    fill: "#da0d29",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768.49,499.66l-4.88-6.92-4.88,6.92h-9.02l9.39-13.32-9.07-12.9h9.02l4.56,6.5,4.56-6.5h9.02l-9.07,12.9,9.39,13.32h-9.02Z",
    fill: "#da0d29",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M396.61,423.7l-8.74-81.42h15.91l4.49,51.4,4.58-51.4h15.17l4.35,51.4,4.35-51.4h16.1l-8.88,81.42h-19.52l-4.07-39.18-3.89,39.18h-19.85Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.89,423.7v-81.42h32.57v15.73h-16.01v15.87h15.36v15.31h-15.36v18.64h17.07v15.87h-33.63Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.1,423.7v-81.42h32.57v15.73h-16.01v15.87h15.36v15.31h-15.36v18.64h17.07v15.87h-33.63Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.31,423.7v-81.42h16.1v32.61l7.59-32.61h16.38l-9.11,37.29,11.01,44.13h-16.89l-8.88-39.41v39.41h-16.19Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.25,423.7v-81.42h32.57v15.73h-16.01v15.87h15.36v15.31h-15.36v18.64h17.07v15.87h-33.63Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.47,423.7v-81.42h16.75l7.49,39v-39h15.73v81.42h-15.91l-8.14-40.71v40.71h-15.91Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M751.86,423.7v-81.42h22.39c5.86,0,10.27,1.63,13.23,4.88,2.96,3.25,4.44,8.01,4.44,14.27v38.12c0,7.71-1.35,13.66-4.05,17.86-2.7,4.19-7.43,6.29-14.18,6.29h-21.84ZM768.24,409.32h2.82c2.99,0,4.49-1.45,4.49-4.35v-42.01c0-2.71-.36-4.46-1.09-5.25-.73-.79-2.2-1.18-4.42-1.18h-1.8v52.78Z",
    fill: "#fff",
    strokeWidth: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M440.75,501.04c-1.91,0-3.84-.09-5.77-.28-12.86-1.25-25.78-6.7-37.36-15.76-14.05-10.98-23.02-25.13-31.7-38.81-6.83-10.78-13.29-20.95-22.05-29.75l6.66-6.63c9.49,9.53,16.52,20.62,23.32,31.35,8.63,13.61,16.78,26.46,29.55,36.44,22.57,17.64,45.15,16.01,57.63,9.25,6.81-3.69,10.97-9,10.58-13.54l9.36-.8c.72,8.39-5.21,17.04-15.46,22.6-7.17,3.88-15.79,5.93-24.75,5.93Z",
    fill: "#242424",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M319.17,380.72s-.05-.04-.07-.06l-.02-.02h0c-.89-.79-1.22-2.08-.74-3.23.09-.22.21-.41.34-.59h0s.92-1.64.92-1.64c.12-.17.22-.35.3-.55.61-1.45-.07-3.11-1.52-3.72l-29.61-12.44c-1.29-.54-2.75-.06-3.48,1.07h0s-2.32,3.13-2.99,4.03c-.06.08-.11.14-.17.21-.84,1.05-4.54,6.17-5.22,15.86,0,0-1.45-7.45,2.65-15.07l-9.35.39-1.36,13.92s4.48,2.73,5.51,3.34c1.03.62,1.16,1.63,1.16,1.63,0,0,.45,2.69.66,7.19.21,4.5,2.57,6.33,2.57,6.33l11,10.31,17.59-17.26c1.34-1.2,3.3-1.49,5.06-.75.49.21.93.49,1.31.82l25.95,24.85,9.29-9.65-29.79-24.98Z",
    fill: "#da0d29",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.93,417.82l.1-3.69-6.63-6.42-7.92,13.94s-1.97,3.22-4.7,3.18c-2.73-.04-4.37-1.53-5.6-2.82-1.24-1.28-13.07-13.18-13.07-13.18l.89-9.56-9.4,9.22,25.16,24.53s.04.04.07.07h0c.25.24.54.44.88.59,1.1.46,2.34.18,3.13-.63l17.12-15.24Z",
    fill: "#242424",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.4,389.68c-1.75-.74-3.71-.44-5.06.75l-4.34,4.26c.53-.13,8.59-1.16,9.52,3.43.65,3.25,1.38,6.41,1.27,11.6-.06,2.6-.14,4.99-.2,6.73-.06,1.61-.11,2.66-.12,2.8-.02.28-.09,1.37.31,2.72.19.68.54,1.43,1.07,2.15.81.41,1.77.69,2.92.7.79.01,1.52-.25,2.16-.64-.48-.09-.89-.22-1.24-.36-1.49-.64-2.05-1.64-2.36-2.61-.14-.48-.2-.94-.21-1.27,0-.16,0-.29,0-.38,0-.04,0-.07,0-.09h0s0-.08,0-.08c0,0,.21-4.38.32-9.62.11-5.25.14-11.33-.23-14.92-.11-1.11-.49-2.09-1.09-2.86-.06-.08-.09-.17-.11-.26l-1.31-1.25c-.38-.33-.82-.61-1.31-.82Z",
    fill: "#242424",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.66,416.38c-.63-.27-.93-.99-.66-1.62.27-.63.99-.93,1.63-.66.63.26.93.99.66,1.63-.27.63-.99.93-1.63.66h0Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.4,374.18l27.56-8.04c.44-.13,3.32-.98,8.37-1.25h0c.88-.05,1.84-.02,2.99.03h0c1.14.06,2.43.15,3.81.27h0c2.77.24,5.94.59,8.95.94h0c6.01.71,11.35,1.45,11.37,1.45h0l-1.03,7.4s-1.01-.14-2.64-.36h0c-1.64-.22-3.9-.51-6.39-.81h0c-4.97-.61-10.91-1.26-14.44-1.44h0c-.99-.05-1.81-.06-2.2-.04h0c-4.25.23-6.52.91-6.57.93h0s-.02,0-.02,0l-27.66,8.06-2.09-7.17h0Z",
    fill: "#242424",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "344.97 422.13 338.52 416.39 349.27 404.13 355.87 409.84 344.97 422.13",
    fill: "#242424",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.74,374.24s-.31.14-.41.62c-.1.48-.06,1.95-1.3,1.14-1.25-.81-3.2-2.37-3.6-2.42l.54-.21,4.77.87Z",
    fill: "#242424",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.42,373.65s-.31.14-.41.62c-.1.48-.06,1.95-1.3,1.14-1.25-.81-3.2-2.37-3.6-2.42l.54-.21,4.77.87Z",
    fill: "#242424",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.12,372.99s-.31.14-.41.62c-.1.48-.06,1.95-1.3,1.14-1.25-.81-3.22-2.21-3.62-2.25l.56-.38,4.77.87Z",
    fill: "#242424",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.38,372.55s-.31.14-.41.62c-.1.48-.06,1.95-1.3,1.14-1.25-.81-3.37-1.86-3.76-1.91l.7-.72,4.77.87Z",
    fill: "#242424",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "270.21 364.98 264.5 366.4 263.24 376.06 268.85 378.9 270.21 364.98",
    fill: "#242424",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317.63 383.91 345.89 407.95 347.02 406.7 318.76 382.66 317.63 383.91",
    fill: "#fff",
    strokeWidth: 0
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBf25WhitePt);
export default __webpack_public_path__ + "static/media/logo_bf25_white_PT.688854e7354ac2a1c0fccc9ab33af36e.svg";
export { ForwardRef as ReactComponent };